import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'

import '@/utils/permission'


let app = createApp(App)
app.use(ElementPlus)
app.use(store)
app.use(router)
app.mount('#app')
